// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"059f6fff","182":"d6f7907f","537":"7fabf1de","781":"09b13006"}[chunkId] + ".chunk.css";
};